import React from "react";
import { Col, ListGroup, ListGroupItem, Row } from "reactstrap";

import { titalize } from "@common/lib/titalize";
import { ColorSwatch } from "../../Menu/ColorSwatch";
import { Color } from "../../helpers";

import './CellTypeList.scss'
import { Dispatch } from "./state/types";

type Props = Readonly<{
  dispatch: Dispatch;
  readonly: boolean;
}>;

interface CellTypeGroups {
  [key: string]: Array<CellType>;
}
interface CellType {
  label: string;
  color: Color;
}

export const cellTypes : CellTypeGroups = {
  'Basic':[
    {label:'Cell', color: Color.fromString("rgba(0,0,0,0)")}, //Transparent
    {label:'Title', color: Color.fromString("#D0B0A0")},
    {label:'Section Title', color: Color.fromString("#F090D0")},
    {label:'Column Header', color: Color.fromString("#A0F010")},
    {label:'Footer', color: Color.fromString("#F0F010")},
    {label:'Image', color: Color.fromString("#FF9033")},
  ],
  'Summary':[
    {label:'Description', color: Color.fromString("#1050F0")},
    {label:'Sum', color: Color.fromString("#50F0D0")},
    {label:'Average', color: Color.fromString("#A0A010")},
    {label:'Min', color: Color.fromString("#B010F0")},
    {label:'Max', color: Color.fromString("#4040F0")},
    {label:'Count', color: Color.fromString("#30D020")},
  ]
}

export const CellTypeList = ({
  dispatch,
  readonly,
}: Props) => {

  const showHeaders = true
  return (
    <div className="celltype-list">
      <Row>
        <Col>
          <ListGroup className={showHeaders ? "indented" : ""}>
            {Object.keys(cellTypes).map((key, groupIndex) => {
              const CellTypeList: Array<CellType> =
              cellTypes[key];
              if (!CellTypeList) {
                return null;
              }
              const labelGroupClasses = ["celltype-group"];
              /*if (currentLabelGroup === key) {
                labelGroupClasses.push("active-label-group");
              }*/
              return (
                <div className={labelGroupClasses.join(" ")} key={key}>
                  {showHeaders && (
                    <ListGroupItem className="header">{titalize(key)} </ListGroupItem>
                  )}
                  {CellTypeList.map((cellType, labelIndex) => {
                    let hotKey = "";
                    if (groupIndex < 9 && labelIndex < 9) {
                      if (showHeaders) {
                        hotKey = `${groupIndex + 1} + ${labelIndex + 1}`;
                      } else {
                        hotKey = `${groupIndex + 1}`;
                      }
                    }
                    const title = titalize(cellType.label);
                    return (
                      <ListGroupItem
                        //active={activeLabel === label}
                        className={`align-items-center d-flex${readonly ? "" : " selectable"}`}
                        key={cellType.label}
                        onClick={() => {
                          if (!readonly) {
                            dispatch({
                              label: cellType.label,
                              type: "CHANGE CURRENT CELL TYPE",
                            });
                          }
                        }}
                        title={title}
                      >
                        <ColorSwatch color={cellType.color} />
                        <div className="flex-fill text-truncate">{title}</div>
                        {hotKey && !readonly && <kbd>{hotKey}</kbd>}
                      </ListGroupItem>
                    );
                  })}
                </div>
              );
            })}
          </ListGroup>
        </Col>
      </Row>
    </div>
  );
};
CellTypeList.displayName = "CellTypeList";
